const STORAGE_KEY = '@eskolare-shop/'

export const getStorage = (name: string, isString = false) => {
  if (typeof localStorage !== 'undefined') {
    const storageItem = localStorage.getItem(STORAGE_KEY + name)
    if (storageItem) {
      if (isString) {
        return storageItem
      }
      return JSON.parse(storageItem)
    }
    return null
  }
  return null
}

export const getAsyncStorage = async (name: string, isString = false) => {
  if (typeof localStorage !== 'undefined') {
    const storageItem = await localStorage.getItem(STORAGE_KEY + name)
    if (storageItem) {
      if (isString) {
        return storageItem
      }
      return JSON.parse(storageItem)
    }
    return null
  }
  return null
}

export const setStorage = (name: string, value: any) => {
  let store = value
  if (typeof value !== 'string') {
    store = JSON.stringify(value)
  }
  localStorage.setItem(STORAGE_KEY + name, store)
}

export const setAsyncStorage = async (name: string, value: any) => {
  let store = value
  if (typeof value !== 'string') {
    store = JSON.stringify(value)
  }
  await localStorage.setItem(STORAGE_KEY + name, store)
}

export const removeStorage = (name: string | Array<string>) => {
  if (typeof name === 'string') {
    localStorage.removeItem(STORAGE_KEY + name)
  } else if (typeof name === 'object') {
    for (let i = 0; i < name.length; i++) {
      localStorage.removeItem(STORAGE_KEY + name[i])
    }
  }
}
